import React from 'react';
import styled from 'styled-components';

const StickerContainer = styled.div`
  position: absolute;
  left: ${({ left }) => (left ? left : 0)}%;
  top: ${({ top }) => (top ? top : 0)}%;
  height: 64px;
  width: 64px;
  z-index: ${({ zIndex }) => (zIndex ? zIndex : 0)};
  transition: transform 85ms ease-in, opacity 85ms ease-in;
  user-select: none;
`;

const StickerImage = styled.img`
  transform: rotate(${({ rotate }) => rotate}deg);
  height: 64px
  width: 64px;
  color: transparent;
  border: 0;
`;

export const Sticker = ({ top, left, rotate, img, zIndex }) => (
  <StickerContainer left={left} top={top} zIndex={zIndex}>
    <StickerImage rotate={rotate} src={img} />
  </StickerContainer>
);



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/Sticker.js